<div class="splash-container">
  <div class="splash-image"></div>
  <div class="loading-tag">Loading...</div>
</div>

